import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bank, CheckCircle, Clock } from "@phosphor-icons/react";

export function DirectDeposit({ status, busy, onStart }) {
  const enabled = status?.payouts_enabled;
  const pending = status?.has_account && !enabled;

  return (
    <Card className="rounded-2xl border-2 border-border p-6 shadow-[6px_6px_0_0_rgba(0,0,0,0.08)]" data-testid="direct-deposit-card">
      <div className="flex items-center gap-2 label-caps mb-3"><Bank size={14} /> Direct Deposit</div>

      {enabled ? (
        <div data-testid="dd-enabled">
          <div className="flex items-center gap-2 text-primary font-semibold text-sm">
            <CheckCircle size={20} weight="fill" /> Direct deposit is active
          </div>
          <p className="text-sm text-muted-foreground mt-2">Your pay will be deposited to your linked bank account via ACH.</p>
          <Button variant="outline" className="rounded-none w-full mt-4" onClick={onStart} disabled={busy} data-testid="dd-manage-button">
            {busy ? "Opening…" : "Update bank details"}
          </Button>
        </div>
      ) : pending ? (
        <div data-testid="dd-pending">
          <div className="flex items-center gap-2 text-amber-600 font-semibold text-sm">
            <Clock size={20} weight="fill" /> Verification in progress
          </div>
          <p className="text-sm text-muted-foreground mt-2">Finish adding your bank details so we can deposit your pay.</p>
          <Button className="rounded-none w-full mt-4" onClick={onStart} disabled={busy} data-testid="dd-continue-button">
            {busy ? "Opening…" : "Continue setup"}
          </Button>
        </div>
      ) : (
        <div data-testid="dd-not-started">
          <p className="text-sm text-muted-foreground mb-4">Set up direct deposit to get paid straight to your bank account each pay period. Bank details are entered securely with Stripe.</p>
          <Button className="rounded-none w-full" onClick={onStart} disabled={busy} data-testid="dd-setup-button">
            {busy ? "Opening…" : "Set up direct deposit"}
          </Button>
        </div>
      )}
    </Card>
  );
}
